import React, { useMemo } from 'react';
import { DownloadInProgress } from '@marty-js/design/src/molecules/download/download-in-progress';
import { Ad } from '../../../../ads/ad';
import { useMetaSeoContext } from '../../../../utils/metaSeoContext';
import { formatDate } from '../../../../atoms/date/utils';

const PreLaunch = ({ item, file, set0verrideAdUnit, handlerStartDownload, handlerRedirectLink, thumbnailsOs }: any) => {
  const metaSeoContext = useMetaSeoContext();
  metaSeoContext.robots = 'noindex, nofollow';
  const adUnit = 'telechargement-prepare-rjs';

  useMemo(() => set0verrideAdUnit(adUnit), [set0verrideAdUnit]);

  return (
    <>
      <DownloadInProgress
        software={item.title}
        updatedAt={formatDate(item.updatedAt, 'dd/MM/yyyy')}
        callback={handlerStartDownload}
        callbackLink={handlerRedirectLink}
        os={file.os}
        fileId={file.id}
        externalLinkOnly={file.externalLinkOnly}
        url={file.url}
        thumbnailsOs={thumbnailsOs}
      />
      <Ad className="Content_1 Mobile_Pos1" adUnitCondition={adUnit} />
    </>
  );
};

export default PreLaunch;
